import React from "react";
import { Col, Row, Skeleton } from "antd";
import ClientInfo from "../ClientInfo/ClientInfo";

export default function ProfileInfo({ profile, isLoading, onProfileUpdate,profileSupplier }) {
  // Este componente ahora actúa como un intermediario.
  // Recibe los datos y la función de actualización y los pasa hacia abajo.

  if (isLoading) {
    // Muestra un esqueleto de carga mientras los datos del perfil se están obteniendo.
    return <div className="profile-container"><Skeleton active avatar={{ size: 180 }} paragraph={{ rows: 10 }} /></div>;
  }

  return (
    <Row gutter={32}>
      <Col span={24}>
        {/* Pasa el perfil y, más importante, la función onProfileUpdate a ClientInfo */}
        <ClientInfo profile={profile} onProfileUpdate={onProfileUpdate} profileSupplier={profileSupplier} />
      </Col>
    </Row>
  );
}
